module.exports = __webpack_public_path__ + "media/images/home/opentable-8f923baf01f4a4ad932b18e77a8c4546.png";